<script>
import UserIcon from "@src/assets/img/icons/pages/sales/user.svg";
import PhoneIcon from "@src/assets/img/icons/pages/sales/phone.svg";
import { formatPhone } from "@src/helpers/phone";
import EmailIcon from "@src/components/ui-design/icons/EmailIcon.vue";
import Money from '@src/mixins/money'

export default {
  mixins: [Money],
  components: {
    EmailIcon,
  },
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      UserIcon,
      PhoneIcon
    };
  },
  methods: {
    formatPhone,
  }
};
</script>

<template>
  <div class="sales-client card-box p-3 px-0">
    <h6 class="sales-details__subtitle">
      <img :src="UserIcon" alt="Ícone do cliente" />
      Cliente
    </h6>
    <div class="mb-3">
      <div>Nome completo</div>
      <p class="sales-client__text ">{{ client.name || '-' }}</p>
    </div>
    <div class="mb-3">
      <div>E-mail</div>
      <p class="sales-client__text d-flex align-items-center">
        <EmailIcon class="mr-1" />
        {{ client.email || '-' }}
      </p>
    </div>
    <div class="mb-3">
      <div>Documento</div>
      <p class="sales-client__text">{{ client.document || '-' }}</p>
    </div>
    <div class="mb-3">
      <div>Telefone</div>
      <p class="sales-client__text  d-flex align-items-center">
        <img :src="PhoneIcon" alt="Ícone de telefone" class="mr-1" />
        {{ formatPhone(client.cellphone) || '-' }}
      </p>
    </div>
    <div class="sales-details__bar"></div>
    <h6 class="sales-details__subtitle">Produto:</h6>
    <div class="d-flex justify-content-between">
      <p>Valor pago:</p>
      <p class="sales-client__text sales-client__money">R$ {{ client.total ? formatMoney(client.total) : '0,00' }}</p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.sales-client {
  &__money {
    font-weight: 600;
  }

  &__text {
    color: #000c0b;
  }
}

img {
  width: 14px;
}
</style>
